module.exports = __webpack_public_path__ + "static/img/bg-home.e1c0153.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc_barocare_conci/bg-home.png
// module id = DiGq
// module chunks = 0